module.exports = __webpack_public_path__ + "static/media/size-chart.20d261f8.jpg";